import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { PhoenixCopySource } from 'app/model/pipeline/copysource/phoenix.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PhoenixCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class PhoenixCopySourceAdapter extends CopySourceAdapter<PhoenixCopySource, Model.PhoenixSource> {
    protected override async _toResource(copySource: PhoenixCopySource): Promise<Model.PhoenixSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(PhoenixCopySource).name);
    }

    protected override async _toModel(
        resource: Model.PhoenixSource,
        copyActivity: CopyActivity
    ): Promise<PhoenixCopySource> {
        return this._toTabularModel(resource, copyActivity, PhoenixCopySource.MODEL);
    }
}
